import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Raffle.module.css";
import { getRaffleShortInfo } from "../../../../Services/Requests";
import { RaffleAdapter, RaffleData } from "../../../../adapters/RaffleAdapter";
import { RaffleCarousel } from "./Raffle.Carousel";
import { Loader } from "../../../../Components/Loader/Loader";
import arrow from "/arrow.svg";
import { useTabStore } from "../../../../Store/TabStore";
export const Raffle: React.FC = () => {
  const navigate = useNavigate();
  const [activeRaffles, setActiveRaffles] = useState<RaffleData[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const setTab = useTabStore((state) => state.setTab);

  useEffect(() => {
    const fetchRaffleInfo = async () => {
      try {
        const response = await getRaffleShortInfo();
        const rafflesData = Array.isArray(response) ? response : [response];
        const { activeRaffles } = RaffleAdapter.adaptRaffles(rafflesData);
        setActiveRaffles(activeRaffles);
        console.log("activeRaffles", activeRaffles);
      } catch (error) {
        console.error("Error fetching raffle info:", error);
      }
    };
    setTab("active");

    fetchRaffleInfo();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          <h3 className={styles.title}>Розыгрыши</h3>
          <button
            className={styles.moreButton}
            onClick={() => navigate("/giveaway")}
          >
            Еще
            <img src={arrow} alt="arrow" />
          </button>
        </div>
        {isLoading ? (
          <Loader />
        ) : activeRaffles.length > 0 ? (
          <RaffleCarousel raffles={activeRaffles} />
        ) : (
          <div className={styles.noRaffles}>
            <p>
              Сейчас нет активных розыгрышей. <br /> Следи за обновлениями,
              чтобы испытать свою удачу!
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
